import { useState } from 'react'

// Who's online, with their colors. Driven by Yjs awareness.
//
// Collapsed by default into a small chip (a stack of colored dots + count) so a
// full classroom doesn't hide the map. Expands into a height-capped, scrolling
// list. The open/closed choice is remembered per browser.
const OPEN_KEY = 'collabmap.presenceOpen'
const STACK_MAX = 4

function loadOpen() {
  try {
    return localStorage.getItem(OPEN_KEY) === '1'
  } catch {
    return false
  }
}

export default function PresencePanel({ people }) {
  const [open, setOpen] = useState(loadOpen)
  const count = people.length

  function toggle() {
    setOpen((o) => {
      const next = !o
      try {
        localStorage.setItem(OPEN_KEY, next ? '1' : '0')
      } catch {
        /* storage unavailable — fine, just don't remember */
      }
      return next
    })
  }

  if (!open) {
    // `people` is sorted self-first by presence.js, so your own dot leads.
    const shown = people.slice(0, STACK_MAX)
    const extra = count - shown.length
    return (
      <button
        type="button"
        className="presence-chip"
        onClick={toggle}
        title="Show who's online"
        aria-expanded="false"
        aria-label={`${count} online — show list`}
      >
        <span className="chip-stack" aria-hidden>
          {shown.map((p) => (
            <span key={p.clientId} className="dot" style={{ background: p.color }} />
          ))}
          {extra > 0 && <span className="dot dot-more">+{extra}</span>}
        </span>
        <span className="chip-count">{count}</span>
        <span className="chip-label">online</span>
      </button>
    )
  }

  return (
    <div className="panel presence-panel" role="region" aria-label="Who's online">
      <div className="panel-head">
        <div className="panel-title">Online · {count}</div>
        <button
          type="button"
          className="icon-btn"
          onClick={toggle}
          title="Collapse"
          aria-label="Collapse the online list"
        >
          –
        </button>
      </div>
      <ul className="presence-list">
        {people.map((p) => (
          <li key={p.clientId}>
            <span className="dot" style={{ background: p.color }} />
            <span className="who">
              {p.name}
              {p.self ? ' (you)' : ''}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
